// extracted by mini-css-extract-plugin
export var chip = "_ca-0";
export var filterDropdown = "_ca-5";
export var filterItem = "_ca-6";
export var icon = "_ca-1";
export var removeButton = "_ca-3";
export var removeIcon = "_ca-4";
export var separator = "_ca-2";